import { defineStore } from 'pinia';

export const useLoanStore = defineStore('loan', {
  state: () => ({
    loanAmount: 0,
    downPayment: 0,
    annualInterestRate: 0,
    loanTermMonths: 36,
    monthlyPayment: 0,
    totalInterest: 0,
    totalPayment: 0,
    selectedRate: 'based of estimated rate' as 'based of estimated rate' | 'custom rate',
    estimatedCreditScore: 'Need improvements',
    customRate: null as number | null,
  }),

  getters: {
    principal: (state) => state.loanAmount - state.downPayment,
    monthlyInterestRate: (state) => state.annualInterestRate / 100 / 12,
  },

  persist: {
    storage: sessionStorage,
  },

  actions: {
    calculateLoan(price: number, downpayment: number, rate: number, term: number) {
      this.loanAmount = price;
      this.downPayment = downpayment;
      this.annualInterestRate = rate;
      this.loanTermMonths = term;

      const P = this.principal;
      const r = this.monthlyInterestRate;
      const n = this.loanTermMonths;

      if (P <= 0 || r <= 0 || n <= 0) {
        this.monthlyPayment = 0;
        this.totalPayment = 0;
        this.totalInterest = 0;
        return;
      }

      const numerator = r * Math.pow(1 + r, n);
      const denominator = Math.pow(1 + r, n) - 1;

      this.monthlyPayment = P * (numerator / denominator);
      this.totalPayment = this.monthlyPayment * this.loanTermMonths;
      this.totalInterest = this.totalPayment - P;
    },

    resetCalculator() {
      this.loanAmount = 0;
      this.downPayment = 0;
      this.annualInterestRate = 0;
      this.loanTermMonths = 0;
      this.monthlyPayment = 0;
      this.totalInterest = 0;
      this.totalPayment = 0;
      this.selectedRate = 'based of estimated rate';
      this.estimatedCreditScore = 'Need improvements';
      this.customRate = null;
    },
  },
});
